/** Matches event_engine_schemas Page universal-template module shape.
 *  Only the sub-object relevant to `type` is included. */
const MODULE_DEFAULTS = {
  hero: { img: '', url: '', alt: '' },
  text: { headline: '', description: '', disclaimer: '' },
  form: { url: '', desktop_height: '', mobile_height: '', custom_fields: {}, expires_at: null }
}

export const createEmptyUniversalModule = type => ({
  type,
  [type]: MODULE_DEFAULTS[type]
})
